import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from 'react';
const DebouncableInput = ({ debounced, inputRef, capture, ...rest }) => {
    const [value, setValue] = useState(rest.value);
    const [timeout, setTimeoutState] = useState(null);
    const prevRestValue = useRef(rest.value);
    const debouncedOnChange = (e, ...args) => {
        e.persist();
        setValue(e.target.value);
        const later = () => {
            setTimeoutState(null);
            if (rest.onChange) {
                // Could not figure out how make TS happy with the args parameter
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                rest.onChange(e, ...args);
            }
        };
        if (timeout) {
            clearTimeout(timeout);
        }
        setTimeoutState(setTimeout(later, 200));
    };
    const handleBlur = (e, ...args) => {
        if (timeout) {
            clearTimeout(timeout);
            setTimeoutState(null);
        }
        if (rest.onChange) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            rest.onChange(e, ...args);
        }
        if (rest.onBlur) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            rest.onBlur(e, ...args);
        }
    };
    useEffect(() => {
        if (debounced && prevRestValue.current !== rest.value) {
            if (timeout) {
                clearTimeout(timeout);
            }
            setValue(rest.value);
            setTimeoutState(null);
        }
        prevRestValue.current = rest.value;
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [rest.value, debounced, timeout, setValue, setTimeoutState]);
    if (debounced) {
        return (_jsx("input", { ...rest, onBlur: handleBlur, onChange: debouncedOnChange, value: value, ref: inputRef, capture: Boolean(capture) }));
    }
    return _jsx("input", { ...rest, ref: inputRef, capture: Boolean(capture) });
};
export default DebouncableInput;
